import { render, staticRenderFns } from "./DashboardElementTotal.vue?vue&type=template&id=7b8dcc89&scoped=true&"
import script from "./DashboardElementTotal.vue?vue&type=script&lang=js&"
export * from "./DashboardElementTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8dcc89",
  null
  
)

export default component.exports